'use client';

var __jsx = React.createElement;
import React from 'react';
import { useTranslations } from 'next-intl';
import AuthFormTemplate from '@modules/shared/auth-flows/templates/auth-form.template';
import EmailInput from '@modules/shared/components/email-input';
import { MuscleButton } from '@modules/shared/components/buttons';
import { useMediaQuery } from 'react-responsive';
import useViewportDimensions from '@lib/hooks/use-viewport-dimensions';
import { BREAKPOINTS } from '@lib/constants';
const CustomerPasswordRecoveryForm = _ref => {
  let {
    onClickCancel = () => {},
    onClickSendEmail = () => {},
    isSendingEmail = false,
    emailEntry = '',
    setEmailEntry = () => {},
    errorSendingEmail = false,
    errorMessage = ''
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    height,
    width
  } = useViewportDimensions(0.8, isMobile ? 0.7 : 0.8);
  return __jsx(AuthFormTemplate, null, __jsx("div", {
    className: "flex flex-col gap-2",
    style: {
      width: isMobile ? width : '384px'
    }
  }, __jsx("div", {
    className: "text-center text-black tx-plg-bold"
  }, t('PASSWORD_RECOVERY')), __jsx("div", {
    className: "text-center text-black tx-psm-light"
  }, t('PASSWORD_RECOVERY_GUIDANCE')), __jsx(EmailInput, {
    value: emailEntry,
    valueIsInvalid: errorSendingEmail,
    onChangeValue: value => setEmailEntry(value),
    fullLength: true,
    required: true,
    labelClassName: "tx-psm-bold"
  }), errorSendingEmail ? __jsx(React.Fragment, null, __jsx("div", {
    className: "text-center text-error-main tx-psm-light"
  }, errorMessage)) : null, __jsx("br", null), __jsx("div", {
    className: "flex flex-row gap-2 w-full justify-center"
  }, __jsx(MuscleButton, {
    variant: "outlineLg",
    onClick: onClickCancel
  }, t('CANCEL')), __jsx(MuscleButton, {
    variant: "solidLg",
    isLoading: isSendingEmail,
    onClick: onClickSendEmail
  }, t('SEND')))));
};
export default CustomerPasswordRecoveryForm;